import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import styles from "./style.module.scss";
import {
  Select,
  notification,
  Spin,
  Checkbox,
  Input,
  Menu,
  Dropdown,
  Button,
  Pagination,
  Tooltip,
  Tabs,
} from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { UNLOGGED } from "util/constants";
import SortPopup from "helperComponents/SortPopup";
import { apiRequest } from "util/services";
import moment from "moment";
import {
  FilePdfFilled,
  LoadingOutlined,
  DeleteFilled,
  ReloadOutlined,
  SearchOutlined,
  InboxOutlined,
  PlusOutlined,
  InfoCircleOutlined,
  DownloadOutlined,
  EditOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import { Progress, Modal as AntModal } from "antd";
import { PlatformStatus } from "helperComponents/Status";
import { Modal } from "components/General/ModalFormComponents";
import RenameDeletePopup from "helperComponents/RenameDeletePopup";
import { useTranslation, Trans } from "react-i18next";
import CreateReport from "./NewReport";
import welcomeStyles from "../Welcome/style.module.scss";
import { appendWorkspaceUserId } from "util/workspaceOwner";
import { buildWorkspaceDeepLink } from "util/workspaceDeepLink";
const { Option } = Select;

function resolveWorkspaceExportProgress(fullReport, completedWidgets, totalWidgets) {
  const completed = Number(completedWidgets) || 0;
  let total = Number(totalWidgets) || 0;
  const widgetIds = fullReport?.widget_ids;
  if (total <= 0 && Array.isArray(widgetIds) && widgetIds.length > 0) {
    total = widgetIds.length;
  }
  return { completed, total };
}

const ReportsDownloads = ({ theme, user, authenticated }) => {
  const [switchTab, setSwitchTab] = useState("reports");
  const [showSortPopup, setShowSortPopup] = useState(false);
  const [status, setStatus] = useState("all");
  const [searchValue, setSearchValue] = useState("");
  const [sortValue, setSortValue] = useState("newest");
  const [currentPage, setCurrentPage] = useState(1);
  const [reports, setReports] = useState([]);
  const [tempReports, setTempReports] = useState([]);
  const [downloads, setDownloads] = useState([]);
  const [tempDownloads, setTempDownloads] = useState([]);
  const [reportLoading, setReportLoading] = useState(false);
  const [createReportLoading, setCreateReportLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [chooseInformationChecked, setChooseInformationChecked] = useState(
    true
  );
  const [aiChecked, setAIChecked] = useState(true);
  const [fixedChecked, setFixedChecked] = useState(false);
  const [customChecked, setCustomChecked] = useState(false);
  const [insightsChecked, setInsightsChecked] = useState(true);
  const [reviewsSwitch, setReviewsSwitch] = useState(false);
  const [dashboards, setDashboards] = useState([]);
  const [name, setName] = useState("");
  const [selectedDashboard, setSelectedDashboard] = useState();
  const [subscriptionStatus, setSubscriptionStatus] = useState();
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [showRenameReport, setShowRenameReport] = useState(false);
  const [showDeleteReport, setShowDeleteReport] = useState(false);
  const [showDeleteDownload, setShowDeleteDownload] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [renameReportValue, setRenameReportValue] = useState("");
  const [reportID, setReportID] = useState(null);
  const [detailsReport, setDetailsReport] = useState(null);
  const [detailsWidgets, setDetailsWidgets] = useState([]);
  const [detailsWidgetsLoading, setDetailsWidgetsLoading] = useState(false);
  const [workspaceMembers, setWorkspaceMembers] = useState([]);
  const [workspaceOwnerId, setWorkspaceOwnerId] = useState(null);
  const [canManageMemberWorkspaces, setCanManageMemberWorkspaces] =
    useState(false);
  const [
    showCreateReportPopupSequence,
    setShowCreateReportPopupSequence,
  ] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const pollingRef = useRef(null);

  // Function to get URL search parameters
  const getUrlParams = () => {
    return new URLSearchParams(location.search);
  };

  // Function to update URL with page parameter
  const updateUrlWithTab = (tab) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("page", tab === "downloads" ? "download" : "report");
    searchParams.delete("tab");
    history.replace({
      pathname: location.pathname,
      search: `?${searchParams.toString()}`,
    });
  };

  // Handle tab switching with URL update
  const handleTabSwitch = (tab) => {
    setSwitchTab(tab);
    setCurrentPage(1);
    updateUrlWithTab(tab);
  };

  useEffect(() => {
    if (authenticated === UNLOGGED) {
      history.push("/");
      return;
    }
  }, []);

  // Handle URL params on component mount/update
  useEffect(() => {
    const urlParams = getUrlParams();
    const pageParam = urlParams.get("page");
    const tabParam = urlParams.get("tab"); // legacy fallback

    if (pageParam === "download" || pageParam === "downloads") {
      setSwitchTab("downloads");
    } else if (pageParam === "report" || pageParam === "reports") {
      setSwitchTab("reports");
    } else if (tabParam === "downloads" || tabParam === "reports") {
      setSwitchTab(tabParam);
    } else {
      setSwitchTab("reports");
    }
  }, [location.search]);

  useEffect(() => {
    if (authenticated === UNLOGGED || !user?.uid) {
      return;
    }
    if (workspaceOwnerId == null) {
      setWorkspaceOwnerId(user.uid);
    }
  }, [authenticated, user?.uid, workspaceOwnerId]);

  useEffect(() => {
    if (authenticated === UNLOGGED || !user?.uid) {
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const response = await apiRequest("welcome/workspace/members", "GET");
        if (cancelled) return;
        const members = Array.isArray(response?.success) ? response.success : [];
        setWorkspaceMembers(members);
        setCanManageMemberWorkspaces(
          response?.can_manage_member_workspaces === true,
        );
      } catch (error) {
        console.error("[ReportsDownloads] workspace members:", error);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authenticated, user?.uid]);

  const viewingOwnExports =
    !workspaceOwnerId || workspaceOwnerId === user?.uid;
  const canMutateReport = useCallback(
    (report) => {
      if (!report) return false;
      const ownerId = report.UserId;
      if (!ownerId || ownerId === user?.uid) return true;
      return canManageMemberWorkspaces;
    },
    [canManageMemberWorkspaces, user?.uid],
  );

  const buildListPayload = useCallback(
    (keywords) =>
      appendWorkspaceUserId(
        {
          user_id: user.uid,
          sort: sortValue,
          keywords,
        },
        workspaceOwnerId,
        user?.uid,
      ),
    [user?.uid, sortValue, workspaceOwnerId],
  );

  const getReportsDownloads = async (keywords) => {
    const searchKeywords =
      keywords !== undefined ? keywords : searchValue;
    if (switchTab === "reports") {
      setReportLoading(true);
      const result = await apiRequest(
        "report/reports/list",
        "POST",
        buildListPayload(searchKeywords),
        true
      );
      if (!result || result.error) {
        notification.error({
          message: result?.error,
        });
      } else {
        setReports(result);
        // tempReports will be recomputed by the filter useEffect
      }
      setReportLoading(false);
    }
    if (switchTab === "downloads") {
      setDownloadLoading(true);
      const result = await apiRequest(
        "report/downloads/list",
        "POST",
        buildListPayload(searchKeywords),
        true
      );
      if (!result.error) {
        setDownloads(result);
        // tempDownloads will be recomputed by the filter useEffect
      } else {
        notification.error({
          message: result.error,
        });
      }
      setDownloadLoading(false);
    }
  };

  useEffect(() => {
    if (!workspaceOwnerId) return;
    getReportsDownloads();
  }, [sortValue, switchTab, workspaceOwnerId]);

  const handleWorkspaceOwnerChange = (nextOwnerId) => {
    if (!nextOwnerId || nextOwnerId === workspaceOwnerId) return;
    setWorkspaceOwnerId(nextOwnerId);
    setCurrentPage(1);
  };

  // Must be declared BEFORE any useEffect that references it to avoid TDZ errors
  const silentRefreshReports = useCallback(async () => {
    const result = await apiRequest(
      "report/reports/list",
      "POST",
      buildListPayload(searchValue),
      true
    );
    if (result && !result.error) {
      // Only update the source-of-truth; the filter useEffect below
      // will recompute tempReports automatically from the new reports + status.
      setReports(result);
    }
  }, [buildListPayload, searchValue]);

  const showWorkspaceOwnerSelect = workspaceMembers.length > 1;
  const workspaceOwnerSelectOptions = useMemo(
    () =>
      workspaceMembers.map((member) => ({
        value: member.user_id,
        label: member.is_self
          ? t("welcome.workspaceOwnerSelf")
          : member.display_name || member.email || member.user_id,
      })),
    [workspaceMembers, t],
  );

  // Keep a ref to the latest silentRefreshReports so the interval never captures a stale closure
  const silentRefreshRef = useRef(null);
  useEffect(() => {
    silentRefreshRef.current = silentRefreshReports;
  }, [silentRefreshReports]);

  // Auto-poll while any My Workspace or Auto Report export is still processing
  useEffect(() => {
    const hasActiveJob = reports.some(
      (r) =>
        (r.ReportType === "My Workspace" || r.ReportType === "Auto Report") &&
        (r.Status === "Pending" || r.Status === "Processing")
    );

    if (hasActiveJob && switchTab === "reports") {
      if (!pollingRef.current) {
        pollingRef.current = setInterval(() => {
          if (silentRefreshRef.current) silentRefreshRef.current();
        }, 5000);
      }
    } else {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    }

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
  }, [reports, switchTab]);

  // Single source-of-truth filter: whenever reports/downloads OR status changes,
  // recompute the displayed list. Having reports+downloads in deps ensures we
  // never read a stale slice when status changes concurrently with a data update.
  useEffect(() => {
    const isAll = !status || status.toLowerCase() === "all";
    if (switchTab === "reports") {
      setTempReports(
        isAll
          ? reports
          : reports.filter((r) => r.Status?.toUpperCase() === status.toUpperCase())
      );
    }
    if (switchTab === "downloads") {
      setTempDownloads(
        isAll
          ? downloads
          : downloads.filter((r) => r.Status?.toUpperCase() === status.toUpperCase())
      );
    }
  }, [status, reports, downloads, switchTab]);

  useEffect(() => {
    setSortValue("newest");
    setStatus("All");
    setSearchValue("");
    setCurrentPage(1);
  }, [switchTab]);

  useEffect(() => {
    setCurrentPage(1);
  }, [status, searchValue, sortValue]);

  useEffect(() => {
    const payload = {
      start_index: 0,
      num_dashboards: 8,
      report: true,
    };
    if (showModal) {
      apiRequest("dashboards/all", "POST", payload, true).then((result) => {
        if (!result.error) {
          setDashboards(result?.dashboards);
        } else {
          notification.error({
            message: result.error,
          });
        }
      });
    }
  }, [showModal]);

  const handleReportDownload = (link) => {
    if (link) {
      window.open(link, "_blank");
    } else {
      notification.error({
        message: t("notifications.36"),
      });
    }
  };

  const reportMenu = (id, reportName, pdfLink, status, fullReport) => {
    const allowMutate = canMutateReport(fullReport);
    return (
    <Menu
      style={{ width: "150px" }}
      theme="dark"
      onClick={() => setReportID(id)}
    >
      <Menu.Item
        key="details"
        icon={<InfoCircleOutlined />}
        onClick={async () => {
          setDetailsReport(fullReport);
          setDetailsWidgets([]);
          if (fullReport?.ReportType === "My Workspace" && fullReport?.report_id) {
            setDetailsWidgetsLoading(true);
            try {
              const res = await apiRequest(`report/welcome/exports/${fullReport.report_id}/widgets`, "GET");
              if (res && Array.isArray(res.success)) {
                setDetailsWidgets(res.success);
              }
            } catch (err) {
              console.error("[DetailsModal] Failed to load widget details:", err);
            } finally {
              setDetailsWidgetsLoading(false);
            }
          }
        }}
      >
        {t("reports_downloads.details")}
      </Menu.Item>
      {allowMutate ? (
        <Menu.Item
          key="rename"
          icon={<EditOutlined />}
          onClick={() => {
            setShowRenameReport(true);
            setRenameReportValue(reportName);
          }}
        >
          {t("button.1")}
        </Menu.Item>
      ) : null}
      {pdfLink && (
        <Menu.Item
          key="download"
          icon={<DownloadOutlined />}
          onClick={() => handleReportDownload(pdfLink)}
        >
          {t("reports_downloads.12")}
        </Menu.Item>
      )}
      {allowMutate &&
        fullReport?.ReportType === "My Workspace" &&
        (status === "Error" || status === "Expired" || status === "Failed") && (
        <Menu.Item
          key="retry"
          icon={<ReloadOutlined />}
          onClick={async () => {
            try {
              await apiRequest(`report/welcome/exports/${fullReport.report_id}/retry`, "POST");
              notification.success({ message: t("common.success"), description: "Export job restarted." });
              getReportsDownloads();
            } catch (_) {
              notification.error({ message: t("common.error"), description: "Could not retry export." });
            }
          }}
        >
          Retry
        </Menu.Item>
      )}
      {allowMutate &&
        status !== "Progress" &&
        status !== "Processing" &&
        status !== "Pending" && (
        <Menu.Item
          key="delete"
          icon={<DeleteOutlined />}
          danger
          onClick={() => setShowDeleteReport(true)}
        >
          {t("button.2")}
        </Menu.Item>
      )}
    </Menu>
    );
  };

  const handleSearch = () => {
    getReportsDownloads(searchValue);
  };

  const ReportItem = ({
    title,
    status,
    dashboardName,
    createdAt,
    reportID,
    dashboardId,
    csvLink,
    pdfLink,
    reportType,
    progressPct,
    completedWidgets,
    totalWidgets,
    fullReport,
  }) => {
    const isWorkspace = reportType === "My Workspace";
    const isAutoReport = reportType === "Auto Report";
    const isWorkspaceLike = isWorkspace || isAutoReport;
    const isActive = status === "Pending" || status === "Processing";
    const isExpired = status === "Expired";
    const isReady = status === "Ready";
    const { completed, total } = resolveWorkspaceExportProgress(
      fullReport,
      completedWidgets,
      totalWidgets,
    );
    const pct = isReady ? 100 : isExpired ? 0 : (progressPct || 0);
    const currentWidgetName = fullReport?.current_widget_name;
    const welcomeGroupId = fullReport?.welcome_group_id || fullReport?.GroupId;

    const renderStatus = () => {
      if (isWorkspaceLike) {
        const progressTitle =
          isActive && currentWidgetName
            ? `${currentWidgetName}`
            : total > 0
            ? t("reports_downloads.widgetProgressHint", {
                completed,
                total,
                remaining: Math.max(0, total - completed),
              })
            : undefined;
        return (
          <div className={styles.progressCell}>
            <div
              className={styles.progressBarTrack}
              title={progressTitle}
            >
              <div
                className={`${styles.progressBarFill} ${isActive ? styles.progressBarAnimated : ""}`}
                style={{
                  width: `${pct}%`,
                  background: isReady
                    ? "#52c41a"
                    : isExpired
                    ? "#d9d9d9"
                    : "linear-gradient(90deg, #6c47d5, #c5b0f5)",
                }}
              />
            </div>
            <div className={styles.progressLabelRow}>
              {isExpired ? (
                <span className={styles.expiredLabel} style={{ color: "#ff4d4f" }}>
                  {t("reports_downloads.6")}
                </span>
              ) : (
                <>
                  {total > 0 && (
                    <span
                      className={styles.widgetCount}
                      title={progressTitle}
                    >
                      {t("reports_downloads.widgetProgress", {
                        completed,
                        total,
                      })}
                    </span>
                  )}
                  <span
                    className={styles.progressPct}
                    style={{ color: isReady ? "#52c41a" : "#6c47d5" }}
                  >
                    {pct}%
                  </span>
                </>
              )}
              {isReady && (
                <>
                  <span className={styles.readyLabel}>Ready</span>
                  {pdfLink && (
                    <a
                      href={pdfLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.downloadInlineBtn}
                      onClick={(e) => e.stopPropagation()}
                      title="Download PDF"
                    >
                      <DownloadOutlined />
                    </a>
                  )}
                  {isAutoReport && welcomeGroupId && (
                    <a
                      href={buildWorkspaceDeepLink({ groupId: welcomeGroupId })}
                      className={styles.openWorkspaceBtn}
                      onClick={(e) => e.stopPropagation()}
                      title={t("reports_downloads.openInWorkspace") || "Open in Workspace"}
                    >
                      <FolderOpenOutlined /> {t("reports_downloads.openInWorkspace") || "Open"}
                    </a>
                  )}
                </>
              )}
              {isActive && (
                <LoadingOutlined className={styles.spinIcon} />
              )}
            </div>
          </div>
        );
      }
      return <PlatformStatus status={status} />;
    };

    return (
      <div className={styles.tableRow}>
        <div className={styles.nameRow}>
          <p style={{ margin: 0 }}>{title}</p>
          {isWorkspace && !viewingOwnExports && fullReport?.created_by ? (
            <span className={styles.reportOwnerBadge}>{fullReport.created_by}</span>
          ) : null}
          {isWorkspace && (
            <span className={styles.reportTypeBadge}>
              {t("reports_downloads.myWorkspace")}
            </span>
          )}
          {isAutoReport && (
            <span className={`${styles.reportTypeBadge} ${styles.autoReportBadge}`}>
              {t("reports_downloads.autoReport") || "Auto"}
            </span>
          )}
        </div>
        <div className={styles.statusContainer}>
          {renderStatus()}
        </div>
        <p className={styles.createdAtRow}>
          {moment(createdAt).format("DD MMM YYYY hh:mm A")}
        </p>
        <div className={styles.moreRow}>
          <Dropdown
            overlay={() => reportMenu(reportID, title, pdfLink, status, fullReport)}
            trigger={["click"]}
          >
            <button className={styles.moreBtn} onClick={(e) => { e.stopPropagation(); setReportID(reportID); }}>
              <EllipsisOutlined />
            </button>
          </Dropdown>
        </div>
      </div>
    );
  };

  const DownloadItem = ({
    exportName,
    status,
    exportDate,
    csvLink,
    id,
    size,
    ownerUserId,
  }) => {
    const allowMutate =
      !ownerUserId || ownerUserId === user?.uid || canManageMemberWorkspaces;
    return (
    <div className={`${styles.tableRow} ${styles.downloadTableRow}`}>
      <Tooltip title={exportName} placement="topLeft">
        <span className={styles.exportNameCell}>
          <p className={styles.exportNameText}>{exportName}</p>
        </span>
      </Tooltip>
      <div className={styles.statusRow}>
        <PlatformStatus status={status} />
      </div>
      <p className={styles.exportDateRow}>
        {moment(exportDate).format("DD MMM YYYY hh:mm")}
      </p>
      <div className={styles.sizeRow}>
        {size}
      </div>
      <div className={styles.downloadRow}>
        {csvLink && (status === "Ready" || status === "InProgress") ? (
          <a
            href={csvLink}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.downloadAction}
          >
            <img
              src={"/assets/download.svg"}
              alt=""
            />
          </a>
        ) : allowMutate ? (
          <img
            src={
              theme === "dark" ? "/assets/trash.svg" : "/assets/trash_black.svg"
            }
            alt=""
            onClick={() => {
              setReportID(id);
              setShowDeleteDownload(true);
            }}
          />
        ) : null}
      </div>
    </div>
    );
  };

  const CustomDropDown = ({
    onChange,
    selectedOption,
    options,
    placeholder,
  }) => (
    <Select
      className={styles.dropdown}
      placeholder={placeholder}
      onChange={onChange}
      value={selectedOption}
      showSearch
      showArrow
      filterOption={(input, option) =>
        option.children.toLowerCase().includes(input.toLowerCase())
      }
    >
      <Select.Option style={{ display: "none" }}>{placeholder}</Select.Option>
      {options?.map((option) => (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      ))}
    </Select>
  );

  const handleReportDelete = async () => {
    setDisableButton(true);
    const payload = {
      report_id: reportID,
    };

    const response = await apiRequest("report/delete", "POST", payload, true);

    if (response.Success) {
      notification.success({
        message: t("notifications.39"),
      });
      setDisableButton(false);
      setShowDeleteReport(false);
      getReportsDownloads();
    } else {
      notification.error({
        message: response.error,
      });
      setShowDeleteReport(false);
      setDisableButton(false);
    }
  };

  const handleDownloadDelete = async () => {
    setDisableButton(true);
    const payload = {
      report_id: reportID,
    };

    const response = await apiRequest("report/delete", "POST", payload, true);

    if (response.Success) {
      notification.success({
        message: t("notifications.40"),
      });
      setDisableButton(false);
      setShowDeleteDownload(false);
      getReportsDownloads();
    } else {
      notification.error({
        message: response.error,
      });
      setShowDeleteDownload(false);
      setDisableButton(false);
    }
  };

  const handleReportRename = async () => {
    setDisableButton(true);
    const payload = {
      report_id: reportID,
      report_name: renameReportValue,
    };

    const response = await apiRequest("report/rename", "POST", payload, true);

    if (response.Success) {
      notification.success({
        message: t("notifications.41"),
      });
      setDisableButton(false);
      setShowRenameReport(false);
      getReportsDownloads();
    } else {
      notification.error({
        message: response.error,
      });
      setShowRenameReport(false);
      setDisableButton(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      getReportsDownloads(searchValue);
    }
  };

  const pageSize = 10;
  const isReportsTab = switchTab === "reports";
  const activeList = isReportsTab ? tempReports : tempDownloads;
  const paginatedList = activeList?.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const getRangeText = (total) => {
    if (!total) return "";
    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, total);
    return `${start}-${end} of ${total}`;
  };

  const tabItems = [
    {
      key: "reports",
      label: t("reports_downloads.1"),
    },
    {
      key: "downloads",
      label: t("reports_downloads.2"),
    },
  ];

  return (
    <div
      className={styles.mainWindow}
      onClick={() => {
        setShowSortPopup(false);
      }}
    >
      {/* Header */}
      <div className={styles.pageHeader}>
        <p className={styles.pageTitle}>{t("dashboard_sidebar.5")}</p>
      </div>

      {/* Tabs */}
      <div className={styles.tabsRow}>
        <Tabs
          activeKey={switchTab}
          onChange={(key) => handleTabSwitch(key)}
          items={tabItems}
          className={styles.reportTabs}
        />
      </div>

      {/* Filters row */}
      <div className={styles.filtersRow}>
        {showWorkspaceOwnerSelect && workspaceOwnerId ? (
          <div className={welcomeStyles.workspaceOwnerSelectWrap}>
            <span className={welcomeStyles.workspaceOwnerSelectLabel}>
              {t("welcome.workspaceOwnerLabel")}
            </span>
            <Select
              className={welcomeStyles.workspaceOwnerSelect}
              value={workspaceOwnerId}
              onChange={handleWorkspaceOwnerChange}
              options={workspaceOwnerSelectOptions}
              disabled={reportLoading || downloadLoading}
              showSearch
              optionFilterProp="label"
              popupMatchSelectWidth={false}
            />
          </div>
        ) : null}
        {switchTab === "reports" && (
          <Select
            style={{ minWidth: 130, width: "max-content" }}
            value={status}
            onChange={(value) => setStatus(value)}
          >
            <Option value="all">{t("reports_downloads.3")}</Option>
            <Option value="progress">{t("reports_downloads.4")}</Option>
            <Option value="ready">{t("reports_downloads.5")}</Option>
            <Option value="expired">{t("reports_downloads.6")}</Option>
          </Select>
        )}
        <Input
          prefix={<SearchOutlined />}
          placeholder={
            switchTab === "reports" ? t("placeholder.13") : t("others.25")
          }
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onPressEnter={handleSearch}
          allowClear
          style={{ width: 220 }}
        />
        <Button
          icon={<ReloadOutlined />}
          onClick={() => {
            setSearchValue("");
            getReportsDownloads("");
          }}
          loading={reportLoading || downloadLoading}
        />
        <div style={{ flex: 1 }} />
        {switchTab === "reports" && (
          <Button
            type="primary"
            icon={<PlusOutlined />}
            className={styles.newReportBtn}
            onClick={() => setShowCreateReportPopupSequence(true)}
          >
            {t("button.10")}
          </Button>
        )}
      </div>

      {/* Reports tab */}
      {switchTab === "reports" ? (
        <Spin spinning={reportLoading}>
          {tempReports?.length > 0 ? (
            <div className={styles.tableContent}>
              <div className={styles.tableHeader}>
                <p className={styles.nameRow}>{t("reports_downloads.7")}</p>
                <p className={styles.statusContainer}>
                  {t("reports_downloads.10")}
                </p>
                <p className={styles.createdAtRow}>
                  {t("reports_downloads.9")}
                </p>
                <p className={styles.moreRow}>{t("reports_downloads.11")}</p>
              </div>
              {paginatedList?.map((elem) => (
                <ReportItem
                  key={elem.report_id}
                  title={elem.Name}
                  status={elem.Status}
                  dashboardName={elem.DashboardName}
                  createdAt={elem.CreationDate}
                  pdfLink={elem.ReportLink}
                  csvLink={elem.CSVLink}
                  dashboardId={elem.DashboardId}
                  reportID={elem.report_id}
                  reportType={elem.ReportType}
                  progressPct={elem.progress_pct}
                  completedWidgets={elem.completed_widgets}
                  totalWidgets={elem.total_widgets}
                  fullReport={elem}
                />
              ))}
            </div>
          ) : (
            !reportLoading && (
              <div className={styles.emptyState}>
                <div className={styles.emptyStateIcon}>
                  <InboxOutlined />
                </div>
                <div className={styles.emptyStateText}>
                  <h3 className={styles.emptyStateTitle}>
                    {t("empty_states.13")}
                  </h3>
                  <p className={styles.emptyStateDesc}>
                    {t("empty_states.14")}
                  </p>
                </div>
              </div>
            )
          )}
          {tempReports?.length > pageSize && (
            <div className={styles.paginationWrap}>
              <span className={styles.paginationTotal}>
                {getRangeText(tempReports?.length)}
              </span>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={tempReports?.length}
                onChange={(page) => setCurrentPage(page)}
                showSizeChanger={false}
              />
            </div>
          )}
        </Spin>
      ) : (
        /* Exports tab */
        <Spin spinning={downloadLoading}>
          {tempDownloads?.length > 0 ? (
            <div className={styles.tableContent}>
              <div className={styles.tableHeader}>
                <p className={styles.exportRow}>
                  {t("reports_downloads.13")}
                </p>
                <p className={styles.statusRow}>{t("reports_downloads.10")}</p>
                <p className={styles.exportDateRow}>
                  {t("reports_downloads.14")}
                </p>
                <p className={styles.sizeRow}>{t("reports_downloads.29")}</p>
                <p className={styles.downloadRow}>
                  {t("reports_downloads.15")}
                </p>
              </div>
              {paginatedList?.map((elem) => (
                <DownloadItem
                  key={elem.report_id}
                  exportName={elem.Name + " " + elem.DashboardName}
                  status={elem.Status}
                  exportDate={elem.CreationDate}
                  csvLink={elem.CSVLink}
                  id={elem.report_id}
                  size={elem?.file_size}
                  ownerUserId={elem.UserId}
                />
              ))}
            </div>
          ) : (
            !downloadLoading && (
              <div className={styles.emptyState}>
                <div className={styles.emptyStateIcon}>
                  <InboxOutlined />
                </div>
                <div className={styles.emptyStateText}>
                  <h3 className={styles.emptyStateTitle}>
                    {t("empty_states.24")}
                  </h3>
                  <p className={styles.emptyStateDesc}>
                    {t("empty_states.25")}
                  </p>
                </div>
              </div>
            )
          )}
          {tempDownloads?.length > pageSize && (
            <div className={styles.paginationWrap}>
              <span className={styles.paginationTotal}>
                {getRangeText(tempDownloads?.length)}
              </span>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={tempDownloads?.length}
                onChange={(page) => setCurrentPage(page)}
                showSizeChanger={false}
              />
            </div>
          )}
        </Spin>
      )}

      {/* Details modal */}
      <AntModal
        open={!!detailsReport}
        onCancel={() => setDetailsReport(null)}
        footer={null}
        title={detailsReport?.Name}
        width={480}
      >
        {detailsReport && (
          <div className={styles.detailsModal}>
            {/* ── Meta rows ── */}
            <div className={styles.detailsRow}>
              <span className={styles.detailsLabel}>{t("reports_downloads.10")}</span>
              <PlatformStatus status={detailsReport.Status} />
            </div>
            <div className={styles.detailsRow}>
              <span className={styles.detailsLabel}>{t("reports_downloads.9")}</span>
              <span>{moment(detailsReport.CreationDate).format("DD MMM YYYY HH:mm")}</span>
            </div>
            <div className={styles.detailsRow}>
              <span className={styles.detailsLabel}>Type</span>
              <span>{detailsReport.ReportType || "—"}</span>
            </div>
            {detailsReport.ReportType === "My Workspace" && (() => {
              const { completed, total } = resolveWorkspaceExportProgress(
                detailsReport,
                detailsReport.completed_widgets,
                detailsReport.total_widgets,
              );
              return (
              <div className={styles.detailsRow}>
                <span className={styles.detailsLabel}>Progress</span>
                <span>
                  {total > 0 && (
                    <span>
                      {t("reports_downloads.widgetProgress", {
                        completed,
                        total,
                      })}
                      {" · "}
                    </span>
                  )}
                  {detailsReport.progress_pct || 0}%
                </span>
              </div>
              );
            })()}
            <div className={styles.detailsRow}>
              <span className={styles.detailsLabel}>Created by</span>
              <span>{detailsReport.created_by || "—"}</span>
            </div>

            {/* ── Widget list (My Workspace only) ── */}
            {detailsReport.ReportType === "My Workspace" && (
              <div className={styles.detailsWidgetSection}>
                <p className={styles.detailsWidgetTitle}>Included Widgets</p>
                {detailsWidgetsLoading ? (
                  <Spin size="small" />
                ) : detailsWidgets.length === 0 ? (
                  <p className={styles.detailsNoWidgets}>No widget details available.</p>
                ) : (
                  <div className={styles.detailsWidgetList}>
                    {detailsWidgets.map((w) => (
                      <div key={w.id} className={styles.detailsWidgetCard}>
                        <div className={styles.detailsWidgetCardHeader}>
                          <span className={styles.detailsWidgetName}>{w.name}</span>
                          {w.metric_requires_ai && (
                            <span className={styles.aiBadge}>AI</span>
                          )}
                        </div>
                        <div className={styles.detailsWidgetMeta}>
                          {w.metric_name && (
                            <span className={styles.detailsWidgetChip}>{w.metric_name}</span>
                          )}
                          {w.group_name && (
                            <span className={styles.detailsWidgetChip} style={{ opacity: 0.7 }}>
                              {w.group_name}
                            </span>
                          )}
                        </div>
                        <div className={styles.detailsWidgetDates}>
                          {w.since && w.until && (
                            <span>{moment(w.since).format("DD MMM YYYY")} → {moment(w.until).format("DD MMM YYYY")}</span>
                          )}
                          {w.pivot_key && w.pivot_values?.length > 0 && (
                            <span className={styles.detailsWidgetPivot}>
                              {w.pivot_key}: {w.pivot_values.join(", ")}
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {(detailsReport.ReportLink || detailsReport.CSVLink) && (
              <div className={styles.detailsActions}>
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={() => handleReportDownload(detailsReport.ReportLink || detailsReport.CSVLink)}
                >
                  {t("reports_downloads.12")}
                </Button>
              </div>
            )}
          </div>
        )}
      </AntModal>

      {switchTab === "reports" && (
        <CreateReport
          open={showCreateReportPopupSequence}
          onClose={() => setShowCreateReportPopupSequence(false)}
          theme={theme}
          getReportsDownloads={getReportsDownloads}
          createLoading={createReportLoading}
          setCreateLoading={setCreateReportLoading}
        />
      )}
      {showModal && (
        <div className={styles.createReportModal}>
          <div className={styles.centerWrapper}>
            <div className={styles.contentWrapper}>
              <div className={styles.modalTitle}>
                <span>{t("reports_downloads.16")}</span>
                <span>
                  <img
                    src={
                      theme === "dark"
                        ? "/assets/help-circle.svg"
                        : "/assets/help-circle-black.svg"
                    }
                    alt=""
                  />
                  {t("topic_library.18")}
                </span>
              </div>
              <div className={styles.modalContent}>
                <div className={styles.modalRow}>
                  <p>{t("reports_downloads.17")}*</p>
                  <Input
                    placeholder={t("placeholder.11")}
                    onChange={(e) => setName(e.target.value)}
                    className={styles.textAreaInput}
                  />
                </div>
                <div className={styles.modalRow}>
                  <p>{t("reports_downloads.18")}</p>
                  <CustomDropDown
                    placeholder={t("placeholder.12")}
                    options={dashboards}
                    selectedOption={selectedDashboard}
                    onChange={(value) => setSelectedDashboard(value)}
                  />
                </div>
                <div className={styles.checkboxContainer}>
                  <div className={`${styles.checkboxRow}`}>
                    <p>{t("reports_downloads.19")}</p>
                  </div>
                  <div className={`${styles.checkboxRow} ${styles.marginLeft}`}>
                    <Checkbox
                      checked={insightsChecked}
                      disabled={!chooseInformationChecked}
                      onChange={(e) => setInsightsChecked(e.target.checked)}
                    />
                    <p
                      className={
                        !chooseInformationChecked && styles.disabledText
                      }
                    >
                      {t("reports_downloads.20")}
                    </p>
                  </div>
                  <div className={styles.verticalLine} />
                  <div className={`${styles.checkboxRow} ${styles.marginLeft}`}>
                    <Checkbox
                      checked={aiChecked}
                      disabled={!chooseInformationChecked}
                      onChange={(e) => setAIChecked(e.target.checked)}
                    />
                    <p
                      className={
                        !chooseInformationChecked && styles.disabledText
                      }
                    >
                      {t("reports_downloads.26")}
                    </p>
                  </div>
                  <div className={styles.verticalLine} />
                  <div className={`${styles.checkboxRow} ${styles.marginLeft}`}>
                    <Checkbox
                      checked={customChecked}
                      disabled={!chooseInformationChecked}
                      onChange={(e) => setCustomChecked(e.target.checked)}
                    />
                    <p
                      className={
                        !chooseInformationChecked && styles.disabledText
                      }
                    >
                      {t("selected_dashboard_sidebar.4")}
                    </p>
                  </div>
                </div>
                <div className={styles.switchContainer}>
                  <div className={styles.dynamicBtn}>
                    <input
                      type="checkbox"
                      id="reviews-switch"
                      checked={reviewsSwitch}
                      disabled={
                        subscriptionStatus?.PackageId < 76 ||
                        subscriptionStatus?.PackageId == 80
                      }
                      onClick={(e) => setReviewsSwitch(e.target.checked)}
                    />
                    <label for="reviews-switch">Toggle</label>
                  </div>
                  <p className={styles.switchText}>
                    {t("reports_downloads.21")}
                  </p>
                </div>

                <div className={styles.btnContainer}>
                  <button onClick={() => setShowModal(false)}>
                    {t("button.3")}
                  </button>
                  <Button loading={createReportLoading} onClick={() => {}}>
                    {t("button.7")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showRenameReport && (
        <RenameDeletePopup
          text={renameReportValue}
          setText={setRenameReportValue}
          label={t("reports_downloads.22")}
          handleAction={handleReportRename}
          closePopup={setShowRenameReport}
          disableBtn={disableButton}
          type="rename"
        />
      )}
      {showDeleteDownload && (
        <Modal
          showModal={showDeleteDownload}
          onClose={() => setShowDeleteDownload(false)}
          onSave={handleDownloadDelete}
          showSaveButton={true}
          showCancelButton={true}
          hideCloseIcon={true}
          textonButton={t("button.2")}
          titleAsset=""
          title={"Delete Download"}
          loadingSaveClick={disableButton}
          widthofmodal="450px"
          disabled={disableButton}
          isDeleteModal={true}
        >
          <p className={styles.deletetext}>
            <Trans
              i18nKey="reports_downloads.28"
              t={t}
              values={{
                reportName: tempDownloads?.find(
                  (item) => item.report_id === reportID
                )?.Name
                  ? tempDownloads?.find((item) => item.report_id === reportID)
                      .Name
                  : tempDownloads?.find((item) => item.report_id === reportID)
                      ?.DashboardName,
              }}
              tOptions={{ interpolation: { escapeValue: false } }}
            />
          </p>
        </Modal>
      )}
      {showDeleteReport && (
        <Modal
          showModal={showDeleteReport}
          onClose={() => setShowDeleteReport(false)}
          onSave={handleReportDelete}
          showSaveButton={true}
          showCancelButton={true}
          hideCloseIcon={true}
          textonButton={t("button.2")}
          titleAsset=""
          title={"Delete Report"}
          loadingSaveClick={disableButton}
          widthofmodal="450px"
          disabled={disableButton}
          isDeleteModal={true}
        >
          <p className={styles.deletetext}>
            <Trans
              i18nKey="reports_downloads.27"
              t={t}
              values={{
                reportName: tempReports?.find(
                  (item) => item.report_id === reportID
                )?.Name
                  ? tempReports?.find((item) => item.report_id === reportID)
                      .Name
                  : tempReports?.find((item) => item.report_id === reportID)
                      ?.DashboardName,
              }}
              tOptions={{ interpolation: { escapeValue: false } }}
            />
          </p>
        </Modal>
      )}
    </div>
  );
};

export default ReportsDownloads;